import React, { PropsWithChildren } from 'react';

import styles from './Scrollable.module.css';

interface Props {
  children: React.ReactNode;
}

export const Scrollable: React.FC<PropsWithChildren<Props>> = ({
  children,
}) => {
  return (
    <div className={styles.scrolling_container}>
      <div className={styles.items}>{children}</div>
    </div>
  );
};
